import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { FormTitle } from "@commonComponents/FormTitle";
import { useSelector } from "react-redux";
import { selectMotList } from "../selectors";
import { selectHeaderTabDS } from "@EUForms/selectors";


export const BorderTransportModeForm = React.memo(({ dataSource = {}, onChange, onSelect, onBlur, disabled }) => {
  const motList = useSelector(selectMotList)
  return (
    <div className="col formContainer">
      <FormTitle className="formTitle" textAlign="start" title="MOT_BORDER" boxNumber="7/4" />
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id="borderTransportMode.modeOfTransport"
            clearable
            isDisabled={disabled}
            name="modeOfTransport"
            label="MOT"
            data={motList}
            onChange={onSelect}
            text={dataSource.modeOfTransport}
            value={dataSource.modeOfTransport}
          />
        </Grid.Column>

        <Grid.Column>
          <InputField
            id="borderTransportMode.grossMass"
            name="grossMass"
            type="number"
            label="GROSS_MASS"
            value={dataSource.grossMass}
            onChange={onChange}
            onBlur={onBlur}
          />

        </Grid.Column>
        <Grid.Column>
          <InputField
            id="borderTransportMode.ucr"
            name="ucr"
            isDisabled={disabled}
            type="text"
            label="UCR"
            value={dataSource.ucr}
            onChange={onChange}
            onBlur={onBlur}
          />

        </Grid.Column>
        
      </Grid.Row>
    </div>
  )
})